import React, { useEffect, useRef } from 'react';
import { useTranslation } from 'react-i18next';
import { CountUpRow, CountUpGrid } from './CountUp';

const Hero = () => {
  const { t } = useTranslation();
  const sectionRef = useRef(null);

  useEffect(() => {
    if (window.IntersectionObserver) {
      const observer = new IntersectionObserver(([entry]) => {
        if (entry.isIntersecting) {
          sectionRef.current.classList.add('visible');
          observer.disconnect();
        }
      }, { threshold: 0.2 });
      
      if (sectionRef.current) {
        observer.observe(sectionRef.current);
      }
      
      return () => observer.disconnect();
    }
  }, []);

  // Données pour les statistiques
  const statsData = [
    {
      value: 40,
      suffix: '%',
      label: t('hero.stats.savings.label')
    },
    {
      value: 25,
      suffix: '+',
      label: t('hero.stats.providers.label')
    },
    {
      value: 30,
      suffix: ' min',
      label: t('hero.stats.time.label')
    }
  ];

  return (
    <section className="hero section-animate" id="accueil" ref={sectionRef}>
      <div className="container">
        <div className="hero-content">
          <div className="hero-text">
            <h1 className="hero-title" dangerouslySetInnerHTML={{ __html: t('hero.title') }} title={t('hero.seo.h1')}>
          </h1>
            <p className="hero-subtitle" dangerouslySetInnerHTML={{ __html: t('hero.subtitle') }}>
          </p>
            <div className="hero-cta">
              <div className="cta-container">
                <a href="#contact" className="btn btn-primary btn-xl btn-ripple glow-primary focus-premium">
                  <span className="btn-icon">📅</span>
                  <span className="btn-text">{t('hero.cta')}</span>
                  <span className="btn-arrow">→</span>
                </a>
              </div>
              
              <div className="hero-trust-indicators">
                <div className="trust-indicator">{t('hero.guarantee1.title')}</div>
                <div className="trust-indicator">{t('hero.guarantee2.title')}</div>
                <div className="trust-indicator">{t('hero.guarantee3.title')}</div>
              </div>
            </div>
          </div>
          <div className="hero-visual">
            <div className="hero-image image-hover-effect">
              <img src="/assets/Illustration.png" alt={t('hero.seo.alt')} />
            </div>
          </div>
        </div>
        
        {/* Section alignée : Garanties et Statistiques */}
        <div className="hero-bottom-section">
          <div className="hero-guarantees">
            <div className="guarantee-card">
              <div className="guarantee-icon">
                <span className="guarantee-check">✓</span>
              </div>
              <div className="guarantee-content">
                <h4>{t('hero.guarantee1.title')}</h4>
                <p>{t('hero.guarantee1.description')}</p>
              </div>
            </div>
            <div className="guarantee-card">
              <div className="guarantee-icon">
                <span className="guarantee-check">✓</span>
              </div>
              <div className="guarantee-content">
                <h4>{t('hero.guarantee2.title')}</h4>
                <p>{t('hero.guarantee2.description')}</p>
              </div>
            </div>
            <div className="guarantee-card">
              <div className="guarantee-icon">
                <span className="guarantee-check">✓</span>
              </div>
              <div className="guarantee-content">
                <h4>{t('hero.guarantee3.title')}</h4>
                <p>{t('hero.guarantee3.description')}</p>
              </div>
            </div>
          </div>
          
          {/* Nouvelle section statistiques responsive */}
          <div className="hero-stats-responsive">
            {/* Version desktop - en ligne */}
            <div className="stats-desktop">
              <CountUpRow items={statsData} />
            </div>
            
            {/* Version mobile - en grille */}
            <div className="stats-mobile">
              <CountUpGrid items={statsData} />
            </div>
          </div>
        </div>
        
        {/* Indicateur centré et cliquable - juste en dessous des garanties */}
        <div className="scroll-indicator-container">
          <a href="#services" className="scroll-indicator-link">
            <div className="scroll-indicator">
              <p className="scroll-text">{t('hero.scroll.text')}</p>
            </div>
          </a>
      </div>
      </div>
    </section>
  );
};

export default Hero; 